








































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { ProductTab } from '@/models/Product';
import { HtmlImageContainer } from '@/models/Image';
import ItemsList from './ItemsList.vue';

@Component({
    components: {
        ItemsList
    }
})
export default class Variants2Tab extends Vue {
    @Prop()
    protected tab!: ProductTab;
    @Prop()
    protected productItemNumber!: string;

    constructor() {
        super();
        // console.log('tab', this.tab);
    }

    // protected getImageLinkUrl(imageId: number): string {
    //     if (
    //         this.tab != null &&
    //         this.tab.Urls != null &&
    //         this.tab.Urls[imageId] != null
    //     ) {
    //         return this.tab.Urls[imageId];
    //     }
    //     return '#';
    // }
}
